
// NATIVE 

// INSTALLED 
import { setBeneficiariosRedux, setSizeFamilyRedux } from './sizeFamilySlice';


// CUSTOM 


export const storeSizeFamily = (size: number): any => {
  

  return async( dispatch: any ) => { 


      let sizeFamily:any = [];

      for (let index = 1; index <= size; index++) {
          sizeFamily.push(index);
      }

      await dispatch( setSizeFamilyRedux(sizeFamily) );

  }

    
}




export const storeFamilyBeneficiarios = (element: any): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( setBeneficiariosRedux(element) );

  }

    
}